import React from "react"
import { createUseStyles } from "react-jss"
import get from "lodash/get"

import { Container, Row, Col } from "../components/layout/grid"

import DriverShipmentCard from "../components/driver-shipment-card"

import colors from "../styles/colors"
import { mediaQueries } from "../styles/breakpoints"
import { fontWeight, fontSize } from "../styles/fonts-constants"

const useStyles = createUseStyles({
  wrapFrame: {
    flexGrow: 1,
    backgroundColor: colors.orange1,
    overflow: "hidden",
    paddingTop: 40,
    paddingBottom: 40,
    color: colors.gray1,
  },
  title: {
    fontFamily: "var(--font-montserrat), sans-serif",
    fontSize: 24,
    lineHeight: 1.83,
    fontWeight: fontWeight.bold,
    color: colors.blue1,
    textAlign: "center",
    marginBottom: 30,
  },
  subtitle: {
    textAlign: "center",
    fontSize: 18,
    fontFamily: '"Montserrat", sans-serif',
    fontWeight: 500,
    marginBottom: 15,
  },
  mapAreaTitle: {
    fontFamily: "var(--font-montserrat), sans-serif",
    fontSize: fontSize.extraLarge,
    fontWeight: fontWeight.bold,
    lineHeight: 1.22,
    color: colors.blue1,
    textAlign: "left",
    marginTop: 60,
    marginBottom: 60,
    paddingLeft: 0,
    paddingRight: 35,
    [mediaQueries.tablet]: {
      textAlign: "center",
      paddingLeft: 35,
    },
    [mediaQueries.desktop]: {
      marginTop: 150,
      marginBottom: 100,
    },
  },
  row: {
    marginLeft: 0,
    marginRight: 0,
    paddingLeft: 0,
  },
  sliderContainer: {
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
    [mediaQueries.tablet]: {
      paddingLeft: "unset",
      paddingRight: "unset",
    },
    [mediaQueries.desktop]: {
      paddingTop: 30,
    },
  },

  "@media screen and (max-width: 576px)": {
    row: {
      marginRight: -15,
      marginLeft: -15,
      "& .shipment-column:nth-last-child(-n+3)": {
        display: "none",
      },
    },
  },
})

const DriverShipmentTestimonials = ({
  shipments,
  title = "Here are some of our previous shipments:",
  subtitle,
}) => {
  const classes = useStyles()

  return (
    <div className="relative page-padding w-full flex flex-col gap-3 bg-orange1 ">
      <Container>
        <h5 className="font-montserrat text-center text-4xl mb-5 text-blue7">
          {title}
        </h5>
        {subtitle && <h6 className={classes.subtitle}>{subtitle}</h6>}
      </Container>
      <section className="grid gap-6  grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 p-0 bg-orange1">
        {shipments &&
          shipments.map((shipment) => (
            <DriverShipmentCard
              title={shipment.title}
              content={`Won by ${shipment.winner} for `}
              amount={`$${shipment.amount}`}
              url={get(shipment, "url", null)}
              mil={shipment.mil}
              key={shipment.id}
            />
          ))}
      </section>
    </div>
  )
}

export default DriverShipmentTestimonials
